/**
 * Built-in Widget Registrations
 *
 * Registers the core inline widgets that ship with core-ui:
 * - mention: People/record tagging with hover preview + click viewer
 * - contact: Inline contact card with call & chat buttons
 *
 * Also registers the default mentionable model (user).
 *
 * This module is imported by MarkdownWidgetDisplay and MarkdownEditor
 * to ensure built-in widgets are always available.
 */

import { registerContactableModel, registerMentionableModel, registerWidget } from './widgetRegistry'

let registered = false

export function ensureBuiltinsRegistered(): void {
  if (registered) return
  registered = true

  // ── Mention widget ──────────────────────────────────────────────
  registerWidget('mention', () => import('./widgets/MentionChip.vue'), {
    package: 'core-ui',
    description: 'Tag a person or record',
    exampleSyntax: '@[Name](model:id)',
    triggerChar: '@',
    icon: 'AtSign',
  })

  // ── Contact card widget ─────────────────────────────────────────
  registerWidget('contact', () => import('./widgets/ContactCard.vue'), {
    package: 'core-ui',
    description: 'Inline contact card with call & chat',
    exampleSyntax: '{{contact:model:id}}',
    triggerChar: '{{contact:',
    icon: 'Contact',
  })

  // ── Default mentionable model ───────────────────────────────────
  registerMentionableModel({
    model: 'user',
    labelField: 'full_name',
    searchField: 'full_name',
    icon: 'User',
    package: 'core-ui',
  })

  // ── Contactable models (models with phone/email via Contactable trait) ──
  registerContactableModel({
    model: 'user',
    labelField: 'full_name',
    searchField: 'full_name',
    icon: 'User',
    package: 'core-ui',
  })

  registerContactableModel({
    model: 'client',
    labelField: 'name',
    searchField: 'name',
    icon: 'Building2',
    package: 'core-ui',
  })
}
